import { userLogsService, type LogAction, type EntityType } from '../services/userLogs'

export const PORTAIS_ATENDIMENTO_LOG_ORIGEM = 'portais/atendimento'

async function persistPortaisLog(
  action: LogAction,
  description: string,
  options?: {
    entityId?: string | null
    entityType?: EntityType
    metadata?: Record<string, unknown>
  }
): Promise<boolean> {
  try {
    const ok = await userLogsService.logUserAction({
      action,
      entityType: options?.entityType ?? 'other',
      entityId: options?.entityId ?? null,
      description,
      metadata: { origem: PORTAIS_ATENDIMENTO_LOG_ORIGEM, ...(options?.metadata || {}) },
    })
    if (!ok) {
      console.warn('Falha ao persistir log (portais atendimento):', description)
    }
    return ok
  } catch (logError) {
    console.warn('Erro ao registrar log (portais atendimento):', logError)
    return false
  }
}

export async function logPortaisAtendimento(
  action: LogAction,
  description: string,
  options?: {
    entityId?: string | null
    entityType?: EntityType
    metadata?: Record<string, unknown>
  }
): Promise<boolean> {
  return persistPortaisLog(action, description, options)
}

export async function logPortaisAtendimentoUpdate(
  entityId: string | null,
  description: string,
  oldValues?: Record<string, unknown>,
  newValues?: Record<string, unknown>,
  additionalMetadata?: Record<string, unknown>
): Promise<boolean> {
  return persistPortaisLog('update', description, {
    entityId,
    entityType: 'parameter',
    metadata: {
      ...additionalMetadata,
      old_values: oldValues,
      new_values: newValues,
    },
  })
}
